import { render, staticRenderFns } from "./webConfigDetailView.vue?vue&type=template&id=315039b8&scoped=true"
import script from "./webConfigDetailView.vue?vue&type=script&lang=js"
export * from "./webConfigDetailView.vue?vue&type=script&lang=js"
import style0 from "./webConfigDetailView.vue?vue&type=style&index=0&id=315039b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315039b8",
  null
  
)

export default component.exports